import { useQuery } from '@tanstack/react-query'
import { Navigate } from 'react-router-dom'
import { supabase } from '@/integrations/supabase/client'
import { FullScreenLoader } from '@/components/FullScreenLoader'

export function AdminRouteGuard({ children }: { children: React.ReactNode }) {
  const { data: isAdmin, isLoading, isError } = useQuery({
    queryKey: ['is_app_admin'],
    queryFn: async () => {
      const { data, error } = await supabase.rpc('is_app_admin' as any)
      if (error) throw error
      return data as boolean
    },
    retry: false,
  })

  if (isLoading) return <FullScreenLoader />

  // See DashboardRouteGuard: a failed request means an invalid session,
  // not a confirmed "not admin" — clear it rather than bounce onward.
  if (isError) {
    supabase.auth.signOut()
    return <Navigate to="/auth?mode=signin" replace />
  }

  if (!isAdmin) return <Navigate to="/auth?mode=signin" replace />
  return <>{children}</>
}
